var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_37111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_37111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 91.6668C21.5278 91.6668 18.5764 90.4515 16.1458 88.021C13.7153 85.5904 12.5 82.639 12.5 79.1668V66.6668H25V8.3335H87.5V79.1668C87.5 82.639 86.2847 85.5904 83.8542 88.021C81.4236 90.4515 78.4722 91.6668 75 91.6668H25ZM75 83.3335C76.1806 83.3335 77.1701 82.9342 77.9688 82.1356C78.7674 81.337 79.1667 80.3474 79.1667 79.1668V16.6668H33.3333V66.6668H70.8333V79.1668C70.8333 80.3474 71.2326 81.337 72.0312 82.1356C72.8299 82.9342 73.8194 83.3335 75 83.3335ZM37.5 37.5002V29.1668H75V37.5002H37.5ZM37.5 50.0002V41.6668H75V50.0002H37.5ZM25 83.3335H62.5V75.0002H20.8333V79.1668C20.8333 80.3474 21.2326 81.337 22.0312 82.1356C22.8299 82.9342 23.8194 83.3335 25 83.3335ZM25 83.3335H20.8333H62.5H25Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.e8cff18d855923fa2c857f739ba267b3.svg";
export { ForwardRef as ReactComponent };